if (!customElements.get('gift-options')) {
  customElements.define(
    'gift-options',
    class GiftOptions extends HTMLElement {
      connectedCallback() {
        this.select = document.getElementById(this.dataset.selectId);
        if (!this.select) return;

        this.list = this.querySelector('[data-gift-list]');
        this.toggle = this.querySelector('[data-gift-toggle]');
        if (!this.list) return;

        this.inputs = Array.from(this.list.querySelectorAll('.gift-options__radio'));
        if (!this.inputs.length) return;

        this.bindEvents();
        this.syncFromSelect();
      }

      bindEvents() {
        this.list.addEventListener('change', (event) => {
          const input = event.target.closest('.gift-options__radio');
          if (!input) return;
          this.select.value = input.value;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        });

        this.select.addEventListener('change', () => this.syncFromSelect());

        if (this.toggle) {
          this.toggle.addEventListener('click', () => {
            const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
            this.toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            this.classList.toggle('gift-options--collapsed', expanded);
          });
        }
      }

      syncFromSelect() {
        const value = this.select.value;
        this.inputs.forEach((input) => {
          input.checked = input.value === value;
        });
      }
    }
  );
}